import { DashboardService, LogStructureTemplatesManager } from '@go-widgets/well-logs-widget';

import { wellLogsWidgetAgent } from 'src/api/wellLogsWidgetAgent';

import type { IServicesCollection } from 'src/packages/di';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    logStructureTemplatesService: LogStructureTemplatesManager;
  }
}

export async function addLogStructureTemplatesService(di: IServicesCollection) {
  const logStructureTemplatesService = new LogStructureTemplatesManager(() => {
    const auth = di.requireServiceAccessor('authService');
    return auth().userInfo.sub;
  }, new DashboardService(wellLogsWidgetAgent));
  await logStructureTemplatesService.getAll();

  di.addSingleton('logStructureTemplatesService', logStructureTemplatesService);
}
